<template>
  <div class="Melamine">
    <div class="title">Butyl Acrylate</div>

    <div class="table">
      <label>Specification:</label>
      <el-table border :data="tableData" stripe>
        <el-table-column prop="Item" label="Item"> </el-table-column>
        <el-table-column prop="Specifications" label="Specifications">
        </el-table-column>
        <!-- <el-table-column prop="Testmethod" label="Test method">
        </el-table-column> -->
      </el-table>
    </div>
    <div class="item-huanhang">
      <label>Package:</label>
      <p>
        In 180kg drum packing, 14.4MT/20'FCL; 25.2mt/40'FCLOr in 25cbm ISO tank,
        21mt per tank
      </p>
    </div>
    <div class="item-huanhang">
      <label>Applications:</label>
      <p>
        N-butyl acrylate can be used as organic synthesis intermediates,
        aadhesives, emulsifiers, coatings, acrylic fiber modification, plastic
        modification, fiberrand fabric processing paper processing agent,
        Leather processing and acrylic rubber, etc
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ACTdetail",
  data() {
    return {
      tableData: [
        { Item: "Purity %(m/m)", Specifications: "99.5min" },
        { Item: "Water content %(m/m)", Specifications: "0.1max" },
        { Item: "Acidity as Acrylic Acid %(m/m)", Specifications: "0.01max" },
        { Item: "Color, Pt-Co", Specifications: "10max" },
        { Item: "Inhibitor as MEHQ mg/kg", Specifications: "10-20" },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.Melamine {
  padding: 10px 30px;
  height: 100%;
  overflow-y: auto;
  label {
    font-size: 20px;
    font-weight: bold;
    height: 40px;
    line-height: 40px;
  }
  p {
    color: gray;
    font-weight: bold;
    line-height: 30px;
  }
  .title {
    font-size: 30px;
    font-weight: bold;
    color: #042a42cf;
  }
  .table {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
  }
  .item {
    margin-top: 10px;
    display: flex;
    align-items: center;
    column-gap: 10px;
  }
  .item-huanhang {
    display: flex;
    flex-direction: column;
    column-gap: 20px;
  }
}
</style>
